import { HIDE_SESSION_EXPIRED_DIALOG } from './types';

export const hideSessionExpiredDialog = (): { type: string } => ({
    type: HIDE_SESSION_EXPIRED_DIALOG,
});
